import linkedin from "../../assets/linkedin.png";
import email from "../../assets/email.png";
import signature from "../../assets/abhiSignature.png";
import github from '../../assets/github.png'
import styled from "styled-components";

const Footer = () => {
    return (
        <Box>
            <hr style={{ marginBottom: "1rem", color: "#fff" }} />
            <div className="footerContainer">
                <div className="footerLeft">
                    <span style={{ fontFamily: "bayon" }} className="title">
                        Begin your AI-enhanced MCQ Practice experience today <br /> and unlock your full tech learning potential.
                    </span>
                    <p className="developedByOnPC">
                        Designed and Developed by{" "}
                        <span
                            style={{
                                fontWeight: "400",
                                fontFamily: "bayon",
                                fontSize: "2.5rem",
                            }}
                        >
                            Abhi
                        </span>{" "}
                        © 2023
                    </p>
                </div>
                <div className="footerRight">
                    <div>
                        {/* <img
                            src={signature}
                            style={{ width: "100px" }}
                            className="signature"
                        /> */}
                    </div>
                    <div className="links">
                        <a
                            href="https://linkedin.com/in/abhipandey1402"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={linkedin} style={{ border: "none" }} />
                        </a>
                        <a
                            href="mailto:pandeyabhi142002@gmail.com"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={email} />
                        </a>
                        <a
                            href="https://github.com/abhipandey1402"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={github} />
                        </a>
                    </div>
                </div>
            </div>
        </Box>
    );
};

export default Footer;


const Box = styled.div`
  margin: 2rem auto;
  padding-bottom: 3rem;
  width: 99.5%;
  background-color: var(--background-color);
  color: var(--color);

  .footerContainer {
    display: flex;
    width: 94%;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;
    margin-top: 3rem;
  }
  
  .footerLeft {
    display: flex;
    flex-direction: column;
    gap: 5rem;


    .title {
        font-size: 2rem;
        font-weight: 500;
        line-height: 3rem;
    }
  }
  
  .links {
    display: flex;
    flex-direction: row;
    gap: 2rem;
  }
  
  .links img {
    background-color: #faf9f6;
    width: 5rem;
    border-radius: 2.5rem;
  }
  
  .footerRight {
    display: flex;
    flex-direction: column;
    align-items: end;
    justify-content: end;
    gap: 5rem;
  }
  
  .developedByOnPC {
    font-size: 2rem;
  }

  `

